import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type AbstractModel, AbstractModelImpl } from '@/services/common/abstract-model';
import type { SuggestionState } from '../type/ai-translation.type';

export const SuggestionModel = Symbol('SuggestionModel');

export interface SuggestionModel extends AbstractModel<SuggestionState> { }

@injectable()
export class SuggestionModelImpl extends AbstractModelImpl<SuggestionState> implements SuggestionModel {
    protected _modelData: SuggestionState = {
        isLoading: true,
        techTopic: '',
        suggestions: [],
        activeSuggestionIdx: 0,
    };
}
